// src/components/ProtectedRoute.tsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authService } from '../../../services/AuthService';
import StorageService from '../../../services/StorageService';

const IS_TEST = process.env.REACT_APP_ENVIRONMENT === 'Test';

interface ProtectedRouteProps {
  element: React.ReactElement;
  redirectTo?: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  element,
  redirectTo = '/login'
}) => {
  const location = useLocation();

  if (IS_TEST) {
    StorageService.clearAll();
    return <Navigate to="/login" replace />;
  }

  const isAuthenticated = authService.isAuthenticated();

  if (!isAuthenticated) {
    authService.clearAuth();
    return <Navigate to={redirectTo} replace />;
  }

  return location.pathname === '/' && redirectTo === '/' ?
    <Navigate to="/" replace /> :
    element;
};